exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#legal-view .aside {\n  float: right;\n  width: 300px;\n  margin-left: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/legal.sass
// module id = 1665
// module chunks = 86